// jQuery + solo el JS "core" de Bootstrap (tooltip, modal, popover, dropdown,
// collapse, etc.). No incluye los plugins pesados de selects/date-pickers:
// esos viven en jquery-pickers.js y solo los importan los componentes que
// realmente los usan (ver src/components/Tables/filters/*, locale-changer,
// BenefitPopOver).
import $ from "jquery";
import "bootstrap";

export default $;
